<template>
    <WelcomeCreditsDialog
        v-if="welcomeCredits.visible.value"
        v-model:visible="welcomeCredits.visible.value"
        :credits-amount="welcomeCredits.creditsAmount.value"
        @close="welcomeCredits.closeDialog"
        @claim-credits="welcomeCredits.claimCredits"
    />
</template>

<script setup lang="ts">
import { WelcomeCreditsDialog, useWelcomeCredits } from 'patsnap-biz';
import '@patsnap-biz/welcome-credits-dialog/lib/style';
import psHttp from '@patsnap/common-ps-http';
import { useI18n } from 'vue-i18n';
import { isCNRegion } from '@eureka/utils/environment';
import { onMounted } from 'vue';
import { accountDeferred } from '@eureka/utils/account';

const { locale } = useI18n()

// 使用 useWelcomeCredits composable
const welcomeCredits = useWelcomeCredits({
    baseURL: import.meta.env.VITE_EUREKA_SERVICE_URI, // 积分服务地址必填: https://qa-eureka-service.zhihuiya.com
    http: psHttp, // 积分服务 HTTP 客户端必填: psHttp
    locale: locale.value as 'cn' | 'en' | 'jp' | 'tw', // 外部传人语言环境必填
});

onMounted(async() => {
    const isCn = isCNRegion()
    if (!isCn) {
        // 海外环境检查欢迎积分资格
        await accountDeferred.promise
        await welcomeCredits.checkWelcomeCredits();
    }
})

</script>

<style lang="scss">
.el-dialog.welcome-credits-dialog {
    --el-dialog-padding-primary: 0;
}
</style>
